// extracted by mini-css-extract-plugin
export default {"avatar":"SmallCard_avatar__x7EId","text":"SmallCard_text__osyNc","button":"SmallCard_button__BgrUx","title":"SmallCard_title__VJnJO","subtitle":"SmallCard_subtitle__rQ1iz"};